import { MaintenanceAlert } from "components/common";
import NotFound from "components/pages/NotFound";

const PageNotFound = () => {
  return (
    <>
      <MaintenanceAlert />
      <NotFound />
    </>
  );
};

export default PageNotFound;
